import React, { memo, useEffect, useState } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import {
  DASHBOARD_ROUTE,
  USER_LOG_ROUTE,
  FORGOT_PASSWORD,
  INITIAL_ROUTE,
  SIDEBAR,
  SIGNIN_ROUTE,
  SIGNUP_ROUTE,
  USERS_ROUTE,
  USERS_DETAILS,
  CUSTOMERS_ROUTE,
  USER_FILTER_PROPERTIES,
  CUSTOMER_HISTORY,
  CUSTOMER_FILTER_MODEL,
  ADD_CUSTOMER,
  USER_FILTER,
  CLEAR_FILTER,
  CUSTOMER_DETAILS,
  PROJECTS_ROUTE,
  ADD_PROJECT,
  PROJECT_DETAILS,
  DAILY_ENTRY_ROUTE,
  CREATE_NEW_ACCOUNT_MODEL,
  BILLING_STATEMENT_LIST_ROUTE,
  BILLING_STATEMENT,
  ADMIN_BILLING_LIST,
  BILLING_ATTACHMENT,
  ADMIN_BILLING_HISTORY,
  PAGE_NOT_FOUND_PATH,
  ADMIN_BILLING_STATEMENT,
  INVOICE_LIST,
  ACCOUNT_LOCKED_PATH,
  INVOICE_FORM,
  CONSOLIDATED_INVOICE_LIST,
  CHANGE_PASSWORD,
  EMAIL_CONFIRMATION,
  CONSOLIDATED_INVOICE_FORM,
  PRINT_INVOICE_FORM,
  PRINT_BROKER_FORM,
  BILLING_INFO_MODEL,
  PRINT_BILLING_STATEMENT,
  PRINT_CONSOLIDATED_INVOICE_FORM,
  PRINT_CUSTOMER,
  PRINT_DASHBOARD_BILLING_STATEMENT,
  PRINT_ORPHANED_BILLING_STATEMENT,
  PRINT_ADMIN_BILLING_STATEMENT,
  BILLING_REVIEW,
} from "./constants/RoutePath";
import Signin from "./components/Signin";
import Dashboard from "./components/Dashboard/Dashboard";
import UserLog from "./components/Manageusers/UserLog";
import ForgotPassword from "./components/ForgotPassword";
import Signup from "./components/Signup";
import {
  PrivateRoute,
  PublicRoute,
  deCryptFun,
} from "./components/comman/CustomFunction";
import Sidebar from "./components/comman/Sidebar";
import Users from "./components/Manageusers/Users";
import UserDetails from "./components/Manageusers/UserDetails";
import Customers from "./components/Customer/Customers";
import UserFilterproperties from "./components/model/UserFilterProperties";
import CustomerHistory from "./components/Customer/CustomerHistory";
import CustomerFilterModel from "./components/model/CustomerFilterModel";
import AddCustomer from "./components/Customer/AddCustomer";
import CustomerDetails from "./components/Customer/CustomerDetails";
import UserFilter from "./components/model/UseFilter";
import UserClearFilter from "./components/model/UserClearFilter";
import Projects from "./components/Projects/Projectindex";
import ProjectDetails from "./components/Projects/ProjectDetails";
import CreateNewAccountModel from "./components/model/CreateNewAccountModel";
import BillingList from "./components/BillingStatement/BillingList";
import BillingStatements from "./components/BillingStatement/BillingStatements";
import AdminBillingList from "./components/AdminBilling/AdminBillingList";
import BillingAttachment from "./components/model/BillingAttachment";
import {
  authHeader,
  getLogUserId,
  getLogUserRole,
  getLogUserRole1,
} from "./components/comman/MainFunction";
import OrphanedHistoryList from "./components/AdminBilling/OrphanedHistoryList";
import PageNotFound from "./components/PageNotFound";
import UseCustomHistory from "./components/comman/UseCustomHistory";
import AdminBillingStatement from "./components/AdminBilling/AdminBillingStatement";
import InvoiceList from "./components/Invoice/InvoiceList";
import { useDispatch, useSelector } from "react-redux";
import { getLoggedUserDetails } from "./redux/action";
import { useToast } from "./components/comman/CustomMessages";
import useSessionHandler from "./components/comman/SessionHandler";
import AccountLocked from "./components/AccountLocked";
import IvoiceForm from "./components/Invoice/InvoiceForm";
import ConsolidatedInvoice from "./components/Invoice/ConsolidatedInvoice";
import ChangePassword from "./components/ChangePassword";
import EmailConfirmation from "./components/EmailConfirmation";
import ConsolidatedInvoiceForm from "./components/Invoice/ConsolidatedInvoiceForm";
import PrintInvoice from "./components/Invoice/PrintInvoice";
import PrintConsolidatedInvoice from "./components/Invoice/PrintConsolidatedInvoice";
import PrintBrokerView from "./components/Invoice/PrintBrokerView";
import BillingInfoModel from "./components/model/BillingInfoModel";
import PrintBillingStatements from "./components/BillingStatement/PrintBillingStatements";
import PrintDashBoardBillingStatements from "./components/BillingStatement/PrintDashBoardBillingStatements";
import ReportDashboard from "./components/Dashboard/ReportDashboard";
import session from "redux-persist/lib/storage/session";
import BillingReview from "./components/BillingReview/BillingReview";
import DailyEntryPage from "./components/DailyEntryPage";

const App = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isActive = useSelector((s) => s.ActiveUserReducer);
  console.log(isActive, "isActitttttttttt");
  let val = isActive && isActive;
  const showToast = useToast();
  const logoutChannel = new BroadcastChannel("logout-channel");
  const loginChannel = new BroadcastChannel("login-channel");

  // const [userSession, setUserSession] = useState(() => {
  //   // Initialize session state from localStorage
  //   const session = localStorage.getItem("isLoggedIn");
  //   return session ? session : null;
  // });

  const [userSession, setUserSession] = useState(
    localStorage.getItem("isLoggedIn") === "true" || null
  );

  const [isLeavingDashboard, setIsLeavingDashboard] = useState(false);

  useEffect(() => {
    if (isPreviewRoute) return;
    const { pathname } = window.location;
    const DASHBOARD_ROUTE = "/dashboard";
    console.log(pathname, "pathanamama", userSession);

    const handlePopState = (event) => {
      const currentPath = window.location.pathname;

      if (currentPath == DASHBOARD_ROUTE && userSession == "true") {
        // setIsLeavingDashboard(true); // Set state to show confirmation
        event.preventDefault(); // Prevent default navigation
        window.history.pushState(null, document.title, window.location.href); // keep the user on the current page
      } else {
        setIsLeavingDashboard(false); // Set state to show confirmation
        window.history.pushState(null, document.title, window.location.href); // keep the user on the current page
      }
    };

    window.addEventListener("popstate", handlePopState);
    logoutChannel.addEventListener("popstate", handlePopState);

    
    return () => {
      window.removeEventListener("popstate", handlePopState);
      logoutChannel.removeEventListener("popstate", handlePopState);
    };
  }, [userSession]);

  useEffect(() => {
    if (isPreviewRoute) return;
    if (isLeavingDashboard) {
      const confirmation = window.confirm("Are you sure you want to sign out?");

      if (confirmation) {
        setIsLeavingDashboard(false);

        // Clear session data & broadcast logout event
        localStorage.clear();
        localStorage.setItem("logout", Date.now()); // Broadcast logout event

        window.location.reload();
        navigate(SIGNIN_ROUTE, { replace: true });
      } else {
        setIsLeavingDashboard(false);
        window.history.pushState(null, document.title, window.location.href);
        // Stay on dashboard, already handled by pushState
      }
    }
  }, [isLeavingDashboard]);

  useEffect(() => {
    if (isPreviewRoute) return;
    const handleStorageEvent = (event) => {
      if (event.key === "logout" && document.hidden) {
        window.location.pathname = SIGNIN_ROUTE;
      } else if (event.key === "loginEvent" && document.hidden) {
        window.location.reload(); // Reload the tab to update the login state
      }
    };

    const handleLogoutMessage = (message) => {
      if (message.data === "logout" && document.hidden) {
        window.location.pathname = SIGNIN_ROUTE;
      }
    };

    const handleLoginMessage = (message) => {
      if (message.data === "login" && document.hidden) {
        window.location.reload(); // Reload the tab to update the login state
      }
    };

    window.addEventListener("storage", handleStorageEvent);
    logoutChannel.addEventListener("message", handleLogoutMessage);
    loginChannel.addEventListener("message", handleLoginMessage);

    return () => {
      window.removeEventListener("storage", handleStorageEvent);
      logoutChannel.removeEventListener("message", handleLogoutMessage);
      loginChannel.removeEventListener("message", handleLoginMessage);
    };
  }, []);

  // useEffect(() => {
  //   const token = authHeader(); // Replace 'authToken' with your actual token key
  //   const roles = getLogUserRole();

  //   if (token) {
  //     // If token exists, user is logged in
  //     if (
  //       window.location.pathname === "/" ||
  //       (window.location.pathname === SIGNIN_ROUTE || window.location.pathname === BILLING_STATEMENT_LIST_ROUTE && roles.includes("Broker") && !roles.includes('Admin'))
  //     ) {
  //       // Redirect to dashboard if on the root or signin page
  //       navigate(BILLING_STATEMENT_LIST_ROUTE);
  //     } else if( window.location.pathname === "/" ||
  //       (window.location.pathname === SIGNIN_ROUTE && roles.includes("Broker") && roles.includes('Admin'))){
  //       navigate(DASHBOARD_ROUTE);
  //     }
  //   } else {
  //     // If no token, ensure the user is on the sign-in page
  //     if (window.location.pathname !== SIGNIN_ROUTE) {
  //       navigate(SIGNIN_ROUTE);
  //     }
  //   }
  // }, []);

  const dispatch = useDispatch();
  let auth = authHeader();

  const isPreviewRoute = location.pathname === "/daily-entry-preview";
  useSessionHandler(isActive?.isActive, isPreviewRoute);

  return (
    <Routes>
      <Route
        exact
        path={SIGNIN_ROUTE}
        element={
          <PublicRoute>
            <Signin />
          </PublicRoute>
        }
      />
      <Route path={SIGNUP_ROUTE} element={<Signup />} />
      <Route
        exact
        path={INITIAL_ROUTE}
        element={
          <PrivateRoute allowedRoles={["Admin", "Broker"]}>
            <Dashboard />
          </PrivateRoute>
        }
      />
      <Route
        exact
        path={DASHBOARD_ROUTE}
        element={
          <PrivateRoute allowedRoles={["Admin", "Broker"]}>
            <Dashboard />
          </PrivateRoute>
        }
      />
      <Route
        exact
        path={FORGOT_PASSWORD}
        element={
          // <PublicRoute>
          <ForgotPassword />
          // </PublicRoute>
        }
      />
      <Route
        exact
        path={USERS_ROUTE}
        element={
          <PrivateRoute allowedRoles={["Admin", "Broker"]}>
            <Users />
          </PrivateRoute>
        }
      />
      <Route
        exact
        path={USER_LOG_ROUTE}
        element={
          <PrivateRoute allowedRoles={["Admin", "Broker"]}>
            <UserLog />
          </PrivateRoute>
        }
      />
      <Route
        exact
        path={CUSTOMERS_ROUTE}
        element={
          <PrivateRoute allowedRoles={["Admin", "Broker"]}>
            <Customers />
          </PrivateRoute>
        }
      />
      <Route
        exact
        path={ADD_CUSTOMER}
        element={
          <PrivateRoute>
            <AddCustomer />
          </PrivateRoute>
        }
      />
      <Route
        path={USERS_DETAILS}
        element={
          <PrivateRoute allowedRoles={["Admin", "Broker"]}>
            <UserDetails />
          </PrivateRoute>
        }
      />
      <Route
        path={USER_FILTER_PROPERTIES}
        element={
          <PrivateRoute>
            <UserFilterproperties />
          </PrivateRoute>
        }
      />
      <Route
        path={CUSTOMER_HISTORY}
        element={
          <PrivateRoute>
            <CustomerHistory />
          </PrivateRoute>
        }
      />
      <Route
        path={CUSTOMER_FILTER_MODEL}
        element={
          <PrivateRoute>
            <CustomerFilterModel />
          </PrivateRoute>
        }
      />
      <Route
        path={USER_FILTER}
        element={
          <PrivateRoute>
            <UserFilter />
          </PrivateRoute>
        }
      />
      <Route
        path={CLEAR_FILTER}
        element={
          <PrivateRoute>
            <UserClearFilter />
          </PrivateRoute>
        }
      />
      <Route
        path={CUSTOMER_DETAILS}
        element={
          <PrivateRoute allowedRoles={["Admin", "Broker"]}>
            <CustomerDetails />
          </PrivateRoute>
        }
      />
      <Route
        path={PROJECTS_ROUTE}
        element={
          <PrivateRoute allowedRoles={["Admin", "Broker"]}>
            <Projects />
          </PrivateRoute>
        }
      />
  <Route
        path={DAILY_ENTRY_ROUTE}
        element={
          <PrivateRoute allowedRoles={["Broker"]}>
            <DailyEntryPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/daily-entry-preview"
        element={<DailyEntryPage />}
      />
      <Route
        path={ADD_PROJECT}
        element={
          <PrivateRoute allowedRoles={["Admin", "Broker"]}>
            <ProjectDetails />
          </PrivateRoute>
        }
      />
      <Route
        path={PROJECT_DETAILS}
        element={
          <PrivateRoute allowedRoles={["Admin", "Broker"]}>
            <ProjectDetails />
          </PrivateRoute>
        }
      />
      <Route
        path={CREATE_NEW_ACCOUNT_MODEL}
        element={<CreateNewAccountModel />}
      />
      <Route
        path={BILLING_STATEMENT_LIST_ROUTE}
        element={
          <PrivateRoute allowedRoles={["Broker"]}>
            <BillingList />
          </PrivateRoute>
        }
      />
      <Route path={BILLING_STATEMENT} element={<BillingStatements />} />
      <Route
        path={ADMIN_BILLING_LIST}
        element={
          <PrivateRoute>
            <AdminBillingList />
          </PrivateRoute>
        }
      />
      <Route
        path={ADMIN_BILLING_HISTORY}
        element={
          <PrivateRoute>
            <OrphanedHistoryList />
          </PrivateRoute>
        }
      />
      <Route
        path={ADMIN_BILLING_STATEMENT}
        element={
          <PrivateRoute>
            <AdminBillingStatement />
          </PrivateRoute>
        }
      />
      <Route
        path={INVOICE_LIST}
        element={
          <PrivateRoute allowedRoles={["Admin", "Broker"]}>
            <InvoiceList />
          </PrivateRoute>
        }
      />
      <Route
        path={CONSOLIDATED_INVOICE_LIST}
        element={
          <PrivateRoute allowedRoles={["Admin", "Broker"]}>
            <ConsolidatedInvoice />
          </PrivateRoute>
        }
      />
      <Route path={BILLING_ATTACHMENT} element={<BillingAttachment />} />
      <Route path={PAGE_NOT_FOUND_PATH} element={<PageNotFound />} />
      <Route path={ACCOUNT_LOCKED_PATH} element={<AccountLocked />} />
      <Route path={CHANGE_PASSWORD} element={<ChangePassword />} />
      <Route path={EMAIL_CONFIRMATION} element={<EmailConfirmation />} />
      <Route
        path={INVOICE_FORM}
        element={
          <PrivateRoute allowedRoles={["Admin", "Broker"]}>
            <IvoiceForm />
          </PrivateRoute>
        }
      />
      <Route
        path={CONSOLIDATED_INVOICE_FORM}
        element={
          <PrivateRoute allowedRoles={["Admin", "Broker"]}>
            <ConsolidatedInvoiceForm />
          </PrivateRoute>
        }
      />
      <Route
        path={PRINT_INVOICE_FORM}
        element={
          <PrivateRoute>
            <PrintInvoice />
          </PrivateRoute>
        }
      />
      <Route
        path={PRINT_BROKER_FORM}
        element={
          <PrivateRoute>
            <PrintBrokerView />
          </PrivateRoute>
        }
      />
      <Route
        path={PRINT_BILLING_STATEMENT}
        element={
          <PrivateRoute>
            <PrintBillingStatements />
          </PrivateRoute>
        }
      />
      <Route
        path={PRINT_DASHBOARD_BILLING_STATEMENT}
        element={
          <PrivateRoute>
            <PrintDashBoardBillingStatements />
          </PrivateRoute>
        }
      />
      <Route
        path={PRINT_ORPHANED_BILLING_STATEMENT}
        element={
          <PrivateRoute>
            <PrintDashBoardBillingStatements />
          </PrivateRoute>
        }
      />
      <Route
        path={PRINT_ADMIN_BILLING_STATEMENT}
        element={
          <PrivateRoute>
            <PrintDashBoardBillingStatements />
          </PrivateRoute>
        }
      />
      <Route
        path={PRINT_CONSOLIDATED_INVOICE_FORM}
        element={
          <PrivateRoute>
            <PrintConsolidatedInvoice />
          </PrivateRoute>
        }
      />
      <Route
        path={PRINT_CUSTOMER}
        element={
          <PrivateRoute>
            <ReportDashboard />
          </PrivateRoute>
        }
      />
      <Route path={BILLING_INFO_MODEL} element={<BillingInfoModel />} />
      <Route path={BILLING_REVIEW} element={<BillingReview />} />
    </Routes>
  );
};

export default App;
